<script setup lang="ts">
import { campusName } from '@/data/campuses';
import type { Category, MapLocation } from '@/data/types';
import PanelHeading from './PanelHeading.vue';

defineProps<{ category: Category; locations: MapLocation[] }>();
const emit = defineEmits<{ back: []; select: [slug: string] }>();
</script>

<template>
  <section>
    <PanelHeading :title="category.label" back-label="Back to categories" @back="emit('back')" />
    <ul class="list">
      <li v-for="loc in locations" :key="loc.slug">
        <button type="button" class="item" @click="emit('select', loc.slug)">
          <span class="item__title">{{ loc.title }}</span>
          <span class="item__campus">{{ campusName(loc.campus) }}</span>
        </button>
      </li>
    </ul>
  </section>
</template>

<style scoped>
.list {
  margin: 0;
  padding: 0;
  list-style: none;
}

.item {
  display: flex;
  flex-direction: column;
  gap: 2px;
  width: 100%;
  padding: 10px 8px;
  border: 0;
  border-bottom: 1px solid var(--border);
  background: none;
  text-align: left;
}

.item:hover {
  background: var(--surface-alt);
}

.item__title {
  font-weight: 600;
}

.item__campus {
  font-size: 13px;
  color: var(--text-muted);
}
</style>
